import { isDefined } from "@clipboard-health/util-ts";

import { PayInfoLabel } from "../../Pay/PayInfoLabel";
import {
  getFormattedShiftPayBreakdown,
  getFormattedShiftPayBreakdownWithShiftAuction,
} from "../getFormattedShiftPayBreakdown";
import { type PayBoostEligibilityResult } from "../PayBoost/getPayBoostEligibility";
import { type ModalShiftAuctionData } from "../types";

interface OpenShiftPayInfoLabelProps {
  offerPay?: number;
  finalPay?: number;
  originalAmount?: number;
  isLoading?: boolean;
  shiftBoost?: number;
  shiftAuction?: Pick<ModalShiftAuctionData["attributes"], "minimumPay" | "maximumPay">;
  payBoostEligibility?: PayBoostEligibilityResult;
}

export function OpenShiftPayInfoLabel(props: OpenShiftPayInfoLabelProps) {
  const {
    offerPay,
    finalPay,
    originalAmount,
    isLoading,
    shiftBoost,
    shiftAuction,
    payBoostEligibility,
  } = props;

  if (isLoading) {
    return <PayInfoLabel isLoading totalPay={undefined} hourlyPay={undefined} />;
  }

  const payBreakdown = isDefined(shiftAuction)
    ? getFormattedShiftPayBreakdownWithShiftAuction(shiftAuction)
    : getFormattedShiftPayBreakdown(offerPay, finalPay, originalAmount, shiftBoost);

  if (!isDefined(payBreakdown)) {
    return null;
  }

  return (
    <PayInfoLabel
      totalPay={payBreakdown.totalPay}
      hourlyPay={payBreakdown.hourlyPay}
      totalWithBoostPay={payBreakdown.totalWithBoostPay}
      payBoostEligibility={payBoostEligibility}
    />
  );
}
